import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const navigate = useNavigate();

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer py-12">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <a href="/" onClick={handleLogoClick} className="block mb-4 hover:opacity-80 transition-opacity">
              <img 
                src="/logo.png" 
                alt="Pravak Global Exports" 
                className="h-12 w-auto"
                style={{ objectFit: 'contain' }}
              />
            </a>
            <h3 className="font-bold text-xl mb-3" style={{color: '#C9A961', fontFamily: 'Playfair Display, serif'}}>
              Pravak Global Exports Private Limited
            </h3>
            <p className="text-[#D4A574] text-sm leading-relaxed">
              {companyInfo.tagline}
            </p>
            <p className="text-[#8B7355] text-sm mt-4 leading-relaxed">
              Premium leather goods export from India to global markets.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{color: '#C9A961'}}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-[#D4A574] hover:text-[#C9A961] transition-colors text-sm">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="text-[#D4A574] hover:text-[#C9A961] transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="/contact" className="text-[#D4A574] hover:text-[#C9A961] transition-colors text-sm">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4" style={{color: '#C9A961'}}>Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-[#D4A574] text-sm">
                <Mail size={18} className="mt-1 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:underline hover:text-[#C9A961] transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#D4A574] text-sm">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>{companyInfo.location}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t" style={{borderColor: 'rgba(212, 165, 116, 0.2)'}}>
          <p className="text-center text-[#8B7355] text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};